(function () {
  const REPLACEMENTS = new Map([
    ["Livrez chaque mois, 14,90 €", "Mensuel : 14,90€/mois"],
    ["Livrez chaque année, 149,00 €", "Annuel : 12,40€/mois (2 mois offerts)"],
  ]);

  function normalize(text) {
    return text
      .replace(/\u00A0/g, " ") // espaces insécables
      .replace(/\s+/g, " ")
      .trim();
  }

  function replaceTextNodes(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];

    while (walker.nextNode()) {
      const node = walker.currentNode;
      const normalized = normalize(node.nodeValue || "");
      if (REPLACEMENTS.has(normalized)) {
        nodes.push(node);
      }
    }

    nodes.forEach((textNode) => {
      const original = normalize(textNode.nodeValue);
      const replacement = REPLACEMENTS.get(original);
      if (!replacement) return;

      textNode.nodeValue = replacement;
    });
  }

  function run() {
    replaceTextNodes(document.body);
  }

  // Initial
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }

  // Observe Shopify Subscriptions injections
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (node && node.nodeType === 1) {
          replaceTextNodes(node);
        }
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // Sécurité supplémentaire
  setTimeout(run, 800);
  setTimeout(run, 2000);
})();